import React from "react";
import { Form, Button } from "antd";
import { IFeatureGroup } from "Features/SubscriptionConfiguration/FeatureGroups/redux/types";

interface FeatureGroupsStepProps {
  selectedFeatureGroups: string[];
  featureGroups: IFeatureGroup[];
  onOpenModal: () => void;
}

const FeatureGroupsStep: React.FC<FeatureGroupsStepProps> = ({
  selectedFeatureGroups,
  featureGroups,
  onOpenModal,
}) => {
  return (
    <div>
      <Form.Item label="Feature Groups">
        <Button
          type="primary"
          onClick={onOpenModal}
          style={{ marginBottom: 16 }}
        >
          Select Feature Groups
        </Button>
        {selectedFeatureGroups.length > 0 && (
          <div style={{ marginTop: 16 }}>
            <p>
              <strong>Selected ({selectedFeatureGroups.length}):</strong>
            </p>
            <ul>
              {selectedFeatureGroups.map((id) => {
                const group = featureGroups.find((g) => g.id === id);
                return (
                  <li key={id}>{group?.displayName || group?.name || id}</li>
                );
              })}
            </ul>
          </div>
        )}
      </Form.Item>
    </div>
  );
};

export default FeatureGroupsStep;

